// extracted by mini-css-extract-plugin
export default {"table":"cityTable_table__ex-c-"};